// Module
var code = "<request-created-statistic></request-created-statistic>\n\n<div class=\"row\">\n    <div class=\"col-sm-6\">\n        <request-status-statistic></request-status-statistic>\n    </div>\n    <div class=\"col-sm-6\">\n        <request-cities-statistic></request-cities-statistic>\n    </div>\n</div>";
// Exports
var _module_exports = code;;
var path = 'template/admin/statistic/general/requests-statistic.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;